import React, { useRef, useState } from "react";
import styles from "./CreateNewsLetter.module.css";

import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import Attachment from "../../components/Attachment/Attachment";

import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

import { FaRegPaperPlane, FaUserPlus } from "react-icons/fa";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";

const dummyStudents = [
  { id: "s1", name: "John" },
  { id: "s2", name: "Steeve" },
  { id: "s3", name: "John" },
  { id: "s4", name: "Steeve" },
  { id: "s5", name: "John" },
  { id: "s6", name: "Steeve" },
  { id: "s7", name: "John" },
  { id: "s8", name: "Steeve" },
  { id: "s9", name: "John" },
  { id: "s10", name: "Steeve" },
];
  
const CreateNewsletter = () => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    date: "",
    time: "",
    rooms: "",
    labels: "",
    notifyStaff: "",
    url: "",
    description: "",
    file: null,
  });
  const filteredStudents = dummyStudents.filter((student) =>
    student.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleCheckboxChange = (id) => {
    setSelectedStudents((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };
  const handleStudentSave = () => {
    console.log("Selected students:", selectedStudents);
    // Add submission logic for students
  };

  const handleStudentCancel = () => {
    setSelectedStudents([]);
    setSearch("");
  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileUpload = (file) => {
    setFormData((prev) => ({ ...prev, file }));
  };
  const handleNewsletterSave = () => {
    console.log("Newsletter Form Submitted:", formData);
    // Add submission logic
  };

  const handleNewsletterCancel = () => {
    setFormData({
      title: "",
      date: "",
      time: "",
      rooms: "",
      labels: "",
      notifyStaff: "",
      url: "",
      description: "",
      file: null,
    });
  };
  

  return (
    <div className={styles.container}>
      <div className={styles.uppercontainer}>
        <div className={styles.header}>
          <HeadingAndIcon
            icon={<FaRegPaperPlane />}
            heading="Create Newsletter"
          />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>

        <div className={styles.content}>
          <div className={styles.section}>
            <HeadingAndIcon icon={<FaRegPaperPlane />} heading="Newsletter" />
          </div>
          <div className={styles.data}>
            <div className={styles.formGrid}>
              <HeadingAndData
                label="Title"
                name="title"
                placeholder="Choose Title"
                value={formData.title}
                onChange={handleChange}
                required
              />
              <CalendarInput
                fieldLabel="Date"
                value={formData.date}
                onChange={(val) => handleDateChange("date", val)}
                required
              />
              <HeadingAndData
                label="Time"
                name="time"
                type="time"
                value={formData.time}
                onChange={handleChange}
                required
              />
              <HeadingAndDropDown
                label="Rooms"
                name="rooms"
                value={formData.rooms}
                onChange={handleChange}
                options={[
                  { label: "Room A", value: "roomA" },
                  { label: "Room B", value: "roomB" },
                ]}
                required
              />
              <HeadingAndDropDown
                label="Labels"
                name="labels"
                value={formData.labels}
                onChange={handleChange}
                options={[
                  { label: "Label 1", value: "label1" },
                  { label: "Label 2", value: "label2" },
                ]}
                required
              />
              <HeadingAndDropDown
                label="Notify Staff"
                name="notifyStaff"
                value={formData.notifyStaff}
                onChange={handleChange}
                options={[
                  { label: "Staff A", value: "staffA" },
                  { label: "Staff B", value: "staffB" },
                ]}
                required
              />
            </div>

            <div className={styles.extraFields}>
              <HeadingAndData
                label="Any URL"
                name="url"
                placeholder="Paste any related URL"
                value={formData.url}
                onChange={handleChange}
              />

              <div className={styles.attachment}>
                <Attachment
                  label="Attachment of Video"
                  accept="video/*"
                  required={true}
                  onFileSelect={handleFileUpload}
                />
              </div>
            </div>

            <div className={styles.textareaWrapper}>
              <label>Description</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Write your message..."
                className={styles.textarea}
              />
            </div>

            <div className={styles.actions}>
              <SaveAndCancel
                onCancel={handleNewsletterCancel}
                onSave={handleNewsletterSave}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.sectionCard}>
        <div className={styles.sectionHeader}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Assign Students" />
        </div>

        <div className={styles.studentdata}>
          <div className={styles.controls}>
            <SearchBar
              placeholder="Student Search..."
              onChange={(e) => setSearch(e.target.value)}
            />
            <Dropdown
              bgColor="var(--Utility_Color9)"
              label="Room"
              options={["Room A", "Room B"]}
            />
          </div>

          <div className={styles.listHeader}>
            <label>
              <input
                type="checkbox"
                checked={selectedStudents.length === filteredStudents.length}
                onChange={(e) =>
                  setSelectedStudents(
                    e.target.checked ? filteredStudents.map((s) => s.id) : []
                  )
                }
              />{" "}
              Select All
            </label>
            <span>{selectedStudents.length} Selected</span>
          </div>

          <div className={styles.grid}>
            {filteredStudents.map((student) => (
              <label key={student.id} className={styles.studentBox}>
                <input
                  type="checkbox"
                  checked={selectedStudents.includes(student.id)}
                  onChange={() => handleCheckboxChange(student.id)}
                />
                <span>{student.name}</span>
              </label>
            ))}
          </div>

          <div className={styles.footerActions}>
            <SaveAndCancel
              onCancel={handleStudentCancel}
              onSave={handleStudentSave}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNewsletter;
